const commentItems = [
  {
    name: '影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimal%20abstract%20geometric%20avatar%20with%20warm%20coral%20tones%2C%20simple%20clean%20design%2C%20modern%20flat%20illustration%20style%2C%20no%20text%20no%20face&width=120&height=120&seq=avatar-01&orientation=squarish',
    date: '2026-07-30',
    content: '糖心影视真的是我用过最好用的免费观影平台了！片源更新速度超快，画质也清晰，追剧党狂喜。推荐给了身边所有朋友！',
    rating: 5,
  },
  {
    name: '电影发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimal%20abstract%20geometric%20avatar%20with%20warm%20amber%20tones%2C%20simple%20clean%20design%2C%20modern%20flat%20illustration%20style%2C%20no%20text%20no%20face&width=120&height=120&seq=avatar-02&orientation=squarish',
    date: '2026-07-28',
    content: '作为一个重度电影爱好者，糖心影视的资源丰富度真的没得说。从经典老片到最新院线，应有尽有。播放流畅不卡顿，给团队点赞！',
    rating: 5,
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimal%20abstract%20geometric%20avatar%20with%20muted%20teal%20tones%2C%20simple%20clean%20design%2C%20modern%20flat%20illustration%20style%2C%20no%20text%20no%20face&width=120&height=120&seq=avatar-03&orientation=squarish',
    date: '2026-07-25',
    content: '不用注册就能看真的太方便了！手机上打开糖心影视网站就能直接看，通勤路上追剧神器。希望一直做下去，会一直支持的！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            用户好评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            来自糖心影视用户的真实评价，你们的喜爱是我们前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((comment) => (
            <div
              key={comment.name}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <p className="text-[11px] text-foreground-400">{comment.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}